import UploadDataStep from './UploadDataStep'

const ManualPassagePlatesPage = () => {
  return <UploadDataStep />
}

export default ManualPassagePlatesPage
